export const project1 = require('./projectbgVid.mp4')